import OrderHub from '@/modules-v2/order-hub/views/index';

const orderHub = [
  {
    path: '/order-hub',
    name: 'OrderHub',
    component: OrderHub,
    meta: {
      title: 'OrderHub',
      requiresAuth: true,
    },
  },
];

export default orderHub;
